import React, { useState, useContext } from 'react';
import { TextField, Checkbox, Button, Typography, Box, Link, Grid, Container, FormControlLabel, Alert, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { postLogin } from '../../services/LoginServices';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/authContext';
import { getMe } from '../../services/LoginServices';

const LoginForm = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [formData, setFormData] = useState({ sel_username: '', sel_pass: '', rememberMe: false });
  const [errorMessage, setErrorMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [migrando, setMigrando] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const verificaDataFiscal = async () => {
    let u = null;
    try { u = JSON.parse(await localStorage.getItem('user')); } catch (e) { }
    return u?.dataFiscal ?? false;
  };

  const redirigirMigracion = (name, cli_user) => {
    setMigrando(true);
    setTimeout(() => {
      navigate('/reset-account', {
        state: {
          name,
          cli_user,
          mensaje: 'Actualizamos nuestro sistema. Creá tu nueva cuenta vinculando tu usuario existente.'
        }
      });
    }, 1500);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    if (!formData.sel_username || !formData.sel_pass) {
      setErrorMessage('Debes ingresar usuario y contraseña');
      return;
    }
    setLoading(true);
    try {
      const res = await postLogin(formData);
      if (res?.data?.token) {
        localStorage.setItem('token', res.data.token);
        await login();

        if (res.data.userType === 'seller') {
          navigate('/');
          return;
        }

        // Llamar getMe directo para tener el dato fresco sin depender del localStorage
        const userMe = await getMe();
        if (userMe?.dataFiscal) {
          navigate('/account');
        } else {
          navigate('/');
        }
      } else if (res?.data?.codigo === 'MIGRAR_CUENTA') {
        redirigirMigracion(res?.data?.name || '', formData.sel_username);
      } else if (res?.data?.codigo === 'CREAR_CUENTA') {
        navigate('/createAccount');
      } else if (res?.data?.message) {
        setErrorMessage(res.data.message);
        setLoading(false);
      } else {
        setErrorMessage('Respuesta inesperada del servidor.');
        setLoading(false);
      }
    } catch (err) {
      // Los 4xx llegan acá
      const data = err.response?.data;
      if (data?.codigo === 'MIGRAR_CUENTA') {
        redirigirMigracion(data?.name || '', formData.sel_username);
      } else if (data?.codigo === 'CREAR_CUENTA') {
        navigate('/createAccount');
      } else {
        setErrorMessage(data?.message || data?.mensaje || 'Usuario o contraseña inválidos');
        setLoading(false);
      }
    }
  };

  const inSx = { '& .MuiOutlinedInput-root': { borderRadius: 'var(--radius-md)', fontFamily: 'var(--font-body)', backgroundColor: 'var(--bg-subtle)', '& fieldset': { border: '2px solid transparent' }, '&:hover fieldset': { border: '2px solid var(--border-hover)' }, '&.Mui-focused fieldset': { border: '2px solid var(--accent)' }, '&.Mui-focused': { backgroundColor: 'var(--bg-card)' } }, '& .MuiInputLabel-root': { fontFamily: 'var(--font-body)', fontSize: '0.9rem' } };

  return (
    <Box sx={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', px: 2, py: 4, background: 'linear-gradient(135deg, var(--bg-main) 0%, var(--bg-subtle) 100%)' }}>
      <Box sx={{ width: '100%', maxWidth: 440, display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: 'var(--bg-card)', p: { xs: 3, sm: 5 }, borderRadius: 'var(--radius-xl)', border: '1px solid var(--border)', boxShadow: 'var(--shadow-lg)', animation: 'fadeInUp 0.5s ease both' }}>
        <Box sx={{ width: 56, height: 56, borderRadius: 'var(--radius-lg)', background: 'linear-gradient(135deg, var(--accent) 0%, #c0392b 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2, boxShadow: '0 4px 16px rgba(233,69,96,0.3)' }}>
          <StorefrontIcon sx={{ color: '#fff', fontSize: 28 }} />
        </Box>
        <Typography sx={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: '1.5rem', color: 'var(--text-primary)', mb: 0.5 }}>Bienvenido</Typography>
        <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: '0.85rem', color: 'var(--text-muted)', mb: 3 }}>Ingresá a tu cuenta para continuar</Typography>

        {errorMessage && <Alert severity="error" sx={{ width: '100%', mb: 2, borderRadius: 'var(--radius-md)', fontFamily: 'var(--font-body)' }}>{errorMessage}</Alert>}
        {migrando && <Alert severity="info" sx={{ width: '100%', mb: 2, borderRadius: 'var(--radius-md)', fontFamily: 'var(--font-body)' }}>Redirigiendo a la migración de cuenta...</Alert>}

        <Box component="form" noValidate sx={{ width: '100%' }} onSubmit={handleSubmit}>
          <TextField margin="normal" fullWidth id="sel_username" label="Usuario o correo electrónico" name="sel_username" value={formData.sel_username} onChange={handleInputChange} autoComplete="email" placeholder="tu@correo.com o usuario" required sx={inSx} />
          <TextField margin="normal" fullWidth id="sel_pass" label="Contraseña" type={showPassword ? 'text' : 'password'} name="sel_pass" value={formData.sel_pass} onChange={handleInputChange} placeholder="••••••••" required sx={inSx} InputProps={{ endAdornment: <InputAdornment position="end"><IconButton onClick={() => setShowPassword(!showPassword)} edge="end" size="small">{showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}</IconButton></InputAdornment> }} />
          <Grid container alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
            <FormControlLabel control={<Checkbox name="rememberMe" checked={formData.rememberMe} onChange={handleInputChange} size="small" sx={{ color: 'var(--text-muted)', '&.Mui-checked': { color: 'var(--accent)' } }} />} label={<Typography sx={{ fontSize: '0.82rem', fontFamily: 'var(--font-body)', color: 'var(--text-secondary)' }}>Recordarme</Typography>} />
            <Link href="forgotPassword" sx={{ fontSize: '0.82rem', fontFamily: 'var(--font-body)', fontWeight: 600, color: 'var(--accent)', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>¿Olvidaste tu contraseña?</Link>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={loading}
            sx={{ mt: 3, mb: 2, py: 1.5, borderRadius: 'var(--radius-md)', fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: '0.95rem', textTransform: 'none', backgroundColor: 'var(--accent)', boxShadow: '0 4px 12px rgba(233,69,96,0.3)', '&:hover': { backgroundColor: 'var(--accent-hover)', transform: 'translateY(-1px)' }, '&:active': { transform: 'scale(0.98)' } }}
          >
            {loading
              ? migrando ? 'Redirigiendo...' : 'Ingresando...'
              : 'Iniciar Sesión'
            }
          </Button>
        </Box>
        <Typography sx={{ fontSize: '0.85rem', fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', mt: 1 }}>¿No tenés una cuenta? <Link href="createAccount" sx={{ fontWeight: 700, color: 'var(--accent)', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>Registrate</Link></Typography>
      </Box>
    </Box>
  );
};
export default LoginForm; 